export const userByEmailBase = /* GraphQL */ `
  query UserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(email: $email, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
      }
      nextToken
    }
  }
`
export const getAttendeeInfo = /* GraphQL */ `
  query GetAttendeeInfo($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      email
      avatar
      title
      company
      country
    }
  }
`

export const getUserBase = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      email
      avatar
      country
      company
      title
      createdAt
      updatedAt
    }
  }
`
